export default __webpack_public_path__ + "static/media/PlanExpired.40501b56.svg";